
import React, { Fragment , useContext, useState } from 'react'
import axios from 'axios';
import toast from 'react-hot-toast';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { UserContext } from '../../Context/UserContext.js';
import { useNavigate } from 'react-router-dom';
import "./sendPrescription.css"
import CustomTitle from '../CustomTitle/CustomTitle.jsx';





export default function SendPrescription() {
   const[isLoading , setIsLoading] = useState(false)
   const navigate = useNavigate() ;
   const {userToken } = useContext(UserContext) ;
   const header = {
      token:`${process.env.REACT_APP_BEARER_TOKEN} ${userToken || localStorage.getItem("token")}`
   }


   const submitData = async (values) => {
      setIsLoading(true)
      const formData = new FormData();
      formData.append('phone', values.phone);
      formData.append('message', values.message);
      formData.append('image', values.image);

      try {
         const { data } = await axios.post(`${process.env.REACT_APP_BASE_URL}/api/v1/prescription`, formData ,   {headers:header});
         if(data.message === "success"){
            setIsLoading(false)
            toast.success("تم أرسال الروشتة")
            navigate("/prescription")
         }
      } catch (error) {
         setIsLoading(false)
         console.error(error);
         toast.error(error.response.data.message)
      }
   }



   const validationSchema = Yup.object({
      phone: Yup.string().required('Phone is required'),
      message: Yup.string().required('Message is required'),
      image: Yup.mixed().required('Image is required'),
   })



   const formik = useFormik({
      initialValues: {
         phone: '',
         message: '',
         image: null,
      },
      validationSchema ,
      onSubmit: submitData
   });


      return (
         <Fragment>
            <CustomTitle title="إرسال روشتة" />
            <div className='container'>
               <h1 className='main-color text-center mt-4'>أرسال الروشتة</h1>
               <div className="row">
                  <div className="col-md-8 offset-md-2" >
                     <form onSubmit={formik.handleSubmit}>
                        {/* Phone Field */}
                        <div className='mt-2'>
                           <label htmlFor="phone" className="form-label">Phone Number:</label>
                           <input
                              type="text"
                              id="phone"
                              name="phone"
                              className="form-control"
                              onChange={formik.handleChange}
                              onBlur={formik.handleBlur}
                              value={formik.values.phone}
                           />
                           {formik.touched.phone && formik.errors.phone && (
                              <div className="text-danger">{formik.errors.phone}</div>
                           )}
                        </div>

                        {/* description Field */}
                        <div className='mt-2'>
                           <label htmlFor="message" className="form-label">Message:</label>
                           <textarea
                              rows={5}
                              cols={20}
                              type="text"
                              id="message"
                              name="message"
                              className=" form-control"
                              onChange={formik.handleChange}
                              onBlur={formik.handleBlur}
                              value={formik.values.message}
                           />
                           {formik.touched.message && formik.errors.message && (
                              <div className="text-danger">{formik.errors.message}</div>
                           )}
                        </div>
                  
                        {/* Image Upload */}
                        <div className='mt-2'>
                           <label htmlFor="image" className="form-label">Upload Image:</label>
                           <input
                              type="file"
                              name="image"
                              className="text-danger form-control"
                              onChange={(event) => {
                                 const file = event.target.files[0];
                                 formik.setFieldValue('image', file);
                              }}
                           />
                           {formik.errors.image && <div className="text-danger">{formik.errors.image}</div>}
                        </div>

                        <div className='text-center'>
                           {isLoading? 
                              <button className="btn bg-main mt-3 w-50"> <i className="fa-solid fa-spinner fa-spin fa-rotate-180 fa-xl"></i></button>
                           : 
                              <button type="submit" className="btn bg-main mt-3 w-50">Submit</button>
                           }
                           
                        </div>
                     </form>
                  </div>
               </div>
            </div>
         </Fragment>
      );

}
